import { FormInstance, Rule } from "antd/lib/form"
import { generalRules } from "~Components/forms/rules/common/general.rules"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import { i18n } from "~Shared/locales/i18n"
import { countInArray } from "~Shared/utils/helper.utils"

export const createTeamRules = (formInstance: FormInstance) => ({
    teamName: [
        generalRules.required,
        stringRules.noExcessWhitespace,
        {
            validator: (_rule, value: string) => {
                const teamNames = formInstance.getFieldsValue().teams.map((e: any) => e.teamName)
                if (value && countInArray(teamNames, value, false) >= 2) {
                    return Promise.reject(i18n.t("validation:duplicate", { value: i18n.t("input:team.team_name") }))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
